import request from '@/utils/request.js';

// 部门管理接口api
export function DepartmentPageList(data) {
    // 获取角色列表
    return request({
        url: '/Department/DepartmentPageList',
        method: 'post',
        apiType: 'java',
        data
    });
}

export function CreateDepartment(data) {
    // 创建部门
    return request({
        url: '/Department/CreateDepartment',
        method: 'post',
        data,
        apiType: 'java'
    });
}

export function DeleteDepartment(data) {
    // 删除部门
    return request({
        url: '/Department/DeleteDepartment?' + `Id=${data.Id}`,
        method: 'post',
        apiType: 'java'
    });
}

export function UpdateDepartment(data) {
    // 修改部门
    return request({
        url: '/Department/UpdateDepartment',
        method: 'post',
        data,
        apiType: 'java'
    });
}

export function GetDepartmentTreeList(data) {
    // 树形部门结构
    return request({
        url: '/Department/GetDepartmentTreeList',
        method: 'post',
        data,
        apiType: 'java'
    });
}

export function GetDepartListById(data) {
    // 获取部门列表通过id 或者idList列表
    return request({
        url: '/Department/GetDepartListById',
        method: 'post',
        apiType: 'java',
        data
    });
}


export function GetDepartList(data) {
    // 获取部门列表(不分页)
    return request({
        url: '/Department/GetDepartList',
        method: 'post',
        data,
        apiType: 'java'
    });
}

